import { apiRequest } from '../core';

export function updateUser(user) {
  const url = new URL(`${process.env.REACT_APP_BACKEND_HOST}/api/identity/user`);
  return apiRequest(url, {
    method: 'PUT',
    credentials: 'same-origin',
    body: JSON.stringify(user),
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
  });
}
